/*
 * Airgo Zone calculator
 * Uses the following plugins:
 * http://www.birdtheme.org/useful/v3tool.html (polygone generator) ** deprecated
 * https://kmltools.appspot.com/geoconv (convert from KML long-lat to lat-long)
 * https://www.npmjs.com/package/load-google-maps-api
 * https://developers.google.com/maps/documentation/javascript/geometry geometry docs
 * https://developers.google.com/maps/documentation/javascript/libraries available google libraries
 */
const initMap = require('load-google-maps-api');
if(document.getElementById('mapRender')){
initOptions = {};
initOptions.key = siteData.googleMapsKey;
initOptions.libraries = ['geometry','places'];
initMap(initOptions);
const query = window.location.search;
const params = new URLSearchParams(query);

initMap().then(function (googleMaps) {
  //elements ids
  elementMapId = 'mapRender';
  elementOriginId = 'origin';
  elementDestinationId = 'destination';
  elementResetId = 'reset'
  elementOriginHiddenId = 'origin_latlng';
  elementDestinationHiddenId = 'destination_latlng';

  // get the selected city in the form
  currentOriginValue = getRadioValue(elementOriginId);
  if(!currentOriginValue){
    $('[data-conditional="origin"]').attr('disabled','disabled');
  }
  type = $( '.main-section' ).attr( 'data-type' );

  mapOptions = {
    mapId: "DEMO_MAP_ID", // Map ID is required for advanced markers.
    zoom: 13,
    mapTypeId: googleMaps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    scrollwheel:  false
  };
  mapOptions = Object.assign(mapOptions,siteData.bookingUrls[type][1].map.mapOptions);//{mapOptions,}
  marker = new googleMaps.marker.AdvancedMarkerElement({
    anchorPoint: new googleMaps.Point(0, -29)
  });
  /*
  * Generates the google maps object and add the requested marker based on the selected city
  * @param {object} data: contains the city object with all location info needed
  */
  function show_map(data){
    //map
    mapOptions.center = new googleMaps.LatLng(data.lat_lng.lat,data.lat_lng.lng);
    map = new googleMaps.Map(document.getElementById(elementMapId), mapOptions);
    //marker
    if(siteData.bookingUrls[type][1].map.include.placeIdMarker){
      geocoder = new googleMaps.Geocoder;
      geocoder.geocode(
        {
          'placeId' : data.place_id
        },
        function(results,status){
          if(status === 'OK'){
            originPlace = results[0];
            setInputLatLng(originPlace,elementOriginHiddenId);
            marker.setPosition(originPlace.geometry.location);
            marker.setMap(map);
          }
        }
      );
    }
    /*
     * Polygons
     */
    googlePolygons = {};
    if(data.polygons && data.polygons !== false){
      data.polygons.forEach(function(polygon){
        googlePolygons[polygon.polygon_name] = {
          'name' : polygon.polygon_name,
          'path' : new googleMaps.Polygon({ paths: [ eval(polygon.polygon_paths) ], strokeColor: '#FF0000' })
        }
      });
    }
    /*
     * Autocomplete & Directions for destination
     */
    var destinationField = document.getElementById(elementDestinationId);
    var options = {
      componentRestrictions: {
        country: 'mx'
      }
    };
    var destinationAutocomplete = new googleMaps.places.Autocomplete(destinationField,options);
    destinationAutocomplete.bindTo('bounds', map);

    if(siteData.bookingUrls[type][1].map.include.directions){
      directionsService = new googleMaps.DirectionsService();
      directionsDisplay = new googleMaps.DirectionsRenderer();
      directionsDisplay.setMap(map);
    }

    /**
     * Autocomplete the destination field if we get the parameter from the url
     */
    if ( params.get('destination') ) {
      // Use .AutoCompleteService since we can't manipulate the .Autocomplete.
      let autocompleteService = new googleMaps.places.AutocompleteService();
      let request = {
        input: document.getElementById(elementDestinationId).value,
        componentRestrictions: {
          country: 'mx'
        }
      }

      // Hidde initial marker.
      marker.setVisible(false);

      // Generate a prediction based on the default value of the destination field.
      autocompleteService.getPlacePredictions(request, (predictionsArr, placesServiceStatus) => {

        // Get the first prediction result.
        let placeRequest = { placeId: predictionsArr[0].place_id };
        let placeService = new googleMaps.places.PlacesService(map);

        // Get the details of the first prediction result.
        placeService.getDetails(placeRequest, (placeResult, placeServiceStatus) => {

          /**
           * Check if user destination is located inside a special zone.
           */
          var specialZone;
          var googlePolygonsKeys = Object.keys(googlePolygons);
          for (var polygon of googlePolygonsKeys) {
            if (googleMaps.geometry.poly.containsLocation(placeResult.geometry.location, googlePolygons[polygon].path)) {
              specialZone = googlePolygons[polygon].name;
            }
          }

          /**
           * Request directions information from google maps
           */
          if (siteData.bookingUrls[type][1].map.include.directions) {
            // Make sure we have an origin place.
            var originPoint;
            var geoCode = new googleMaps.Geocoder;
            geoCode.geocode({ 'placeId' : data.place_id }, function(results, status) {
              if (status === 'OK') {
                originPoint = results[0];

                var directionsService = new googleMaps.DirectionsService();
                var request = {
                  origin: originPoint.geometry.location,
                  destination: placeResult.geometry.location,
                  travelMode: googleMaps.DirectionsTravelMode.DRIVING
                };
    
                directionsService.route(request, function(response, status) {
                  if (status == googleMaps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                    var destinationData = {
                      'distance' : getTotalDistance(response),
                      'special_zone' : specialZone,
                      'destinationPlace' : placeResult,
                      'city_id' : data.id
                    };
                    setDestinationData(destinationData);
                  } else {
                    console.log('Error getting directions.');
                  }
                });
              }
            });
          }
        });
      });

    }

    destinationAutocomplete.addListener('place_changed', function() {
      marker.setVisible(false);
      destinationPlace = destinationAutocomplete.getPlace();

      const resolvePlace = function() {
        return new Promise(function(resolve, reject) {
          if ( destinationPlace.place_id === 'ChIJd_3kqWxFIYQRkJsoWqUG7ek' ) {
            const placesService = new googleMaps.places.PlacesService(map)
            placesService.getDetails({
              placeId: 'ChIJv0PV8-laIYQRLnVYr9bDaaY',
              fields: ['name', 'rating', 'geometry', 'address_components']
            }, function( fixedPlace ) {
              destinationField.value = fixedPlace.name;
              resolve( fixedPlace )
            })
          } else {
            resolve(destinationPlace)
          }
        })
      }

      resolvePlace().then(function( destinationPlace ) {
        setInputLatLng(destinationPlace,elementDestinationHiddenId);
        //destinationField.value = destinationPlace.name;
        if(!siteData.bookingUrls[type][1].map.include.directions){
          //update new marker
          marker.setAnimation(googleMaps.Animation.DROP);
          marker.setPosition(destinationPlace.geometry.location);
          marker.setMap(map);
          marker.setVisible(true);
          marker.setDraggable(true);
          map.setCenter(marker.getPosition());
          map.setZoom(18);
          var infowindow = new google.maps.InfoWindow();
          infowindow.setContent(siteData.lang[8]);
          infowindow.open(map, marker);
        }
        /*
         * Check if user destination is located inside a special zone
         */
        var specialZone;
        var googlePolygonsKeys = Object.keys(googlePolygons);
        for(var polygon of googlePolygonsKeys){
          if(googleMaps.geometry.poly.containsLocation(destinationPlace.geometry.location,googlePolygons[polygon].path)){
            specialZone = googlePolygons[polygon].name;
          }
        }
        /*
         * Request directions information from google maps
         */
        if(siteData.bookingUrls[type][1].map.include.directions){
          var directionsService = new googleMaps.DirectionsService();
          var request = {
            origin: originPlace.geometry.location,
            destination: destinationPlace.geometry.location,
            travelMode: googleMaps.DirectionsTravelMode.DRIVING
          };
          directionsService.route(request, function(response, status) {
            if (status == googleMaps.DirectionsStatus.OK) {
              directionsDisplay.setDirections(response);
              var destinationData = {
                'distance' : getTotalDistance(response),
                'special_zone' : specialZone,
                'destinationPlace' : destinationPlace,
                'city_id' : data.id
              };
              setDestinationData(destinationData);
            }else{
              //error here
            }
          });
        }
      })
    });
  }

  if(currentOriginValue){
    /*
     * load the map when an initial value is selected
     */
    get_data({
      object : 'city',
      params : {
        id : currentOriginValue,
        type : type
      }
    },function(cities){
      show_map(cities);
    });
  }

  function getRadioValue(radioGroup){
    for (var i = 0; i < document.getElementsByName(radioGroup).length; i++){
      if (document.getElementsByName(radioGroup)[i].checked){
        return document.getElementsByName(radioGroup)[i].value;
      }
    }
  }

  document.getElementsByName(elementOriginId).forEach(function(element){
    /*
     * load the map when city value is updated
     */
    element.addEventListener('change', function(){
      var inputValue = element.value;

      loadMapForOrigin(inputValue);
    });
  });

  function loadMapForOrigin(inputValue) {
    if(inputValue){
      $('[data-conditional="origin"]').removeAttr('disabled');
      get_data({
        object : 'city',
        params : {
          id : inputValue
        }
      },function(cities){
        cities.type = type;
  
        if (cities.pinned_tours && cities.pinned_tours !== "")
          $('#toursWrapper').removeClass('hide');
        else
          $('#toursWrapper').addClass('hide');
  
        show_map(cities);
      });
    }else{
      //hide map
    }
  }

  window.onload = () => {
    const originElements = document.getElementsByName(elementOriginId);
    if(originElements == undefined) return;
    if(originElements.length != 2) return;
    
    originElements[0].checked = true;
    originElements[1].checked = true;

    loadMapForOrigin(originElements[1].value);
  };
});

/*
 * Ajax call to get city information
 */
function get_data(params,callback){
  $.get(siteData.ajaxEndpoint, {
    action  : 'booking_handler',
    object  : params.object,
    params  : params.params
  })
  .done(function(data){
    if(data.success){
      callback(data.data);
    }
  });
}

/*
 * Set the latitude & longitud in an specific input field
 */
function setInputLatLng(location,inputId){
  if(location){
    var latlng = location.geometry.location.lat()+','+location.geometry.location.lng();
    document.getElementById(inputId).value = latlng;
  }else{
    document.getElementById(inputId).value = null;
  }
}

/*
 * Calculates total distance between departure and destination location
 */
function getTotalDistance(result) {
  var total = 0;
  var myroute = result.routes[0];
  for (i = 0; i < myroute.legs.length; i++) {
    total += myroute.legs[i].distance.value;
  }
  return total;
}

/*
 * Generates the SKU to request, based on the distance or destination place
 */
function setDestinationData(data){
  var tempButtonText = $('#bookingStep1Submit').val();
  $('#bookingStep1Submit').prop('disabled',true);
  $('#bookingStep1Submit').val( siteData.lang[0] );
  get_data({
    object : 'sku',
    params : {
      data : {
        'distance' : data.distance,
        'special_zone' : data.special_zone,
        'address' : data.destinationPlace.address_components,
        'city_id' : data.city_id
      }
    }
  },function(sku){
    if(!sku.errors){
      $('#sku').val(sku);
      $('#bookingStep1Submit').prop('disabled',false);
      $('#bookingStep1Submit').val( tempButtonText );

      // Simulate click after rendering url destination point.
      if ( params.get('destination') && window.innerWidth >= 770 ) {
        $('#bookingStep1Submit').trigger('click');
      }
    }else{
      $('#bookingStep1Submit').val( siteData.lang[1] );
      alert(sku.errors.description);
    }
  });
}
if (window.matchMedia('(max-width: 767px)').matches){
  if($('#destination').length > 0){
    $('#destination').on('focus', function(){
      if(!$('#map').hasClass('active-mobile')){
        $('#map').addClass('active-mobile');
        $('#map').find('.button-map-wrapper').show();
        $(this).parent().children().detach().appendTo('#autocompleteMobile');
      }
    });
  }
  if($('.button-map').length > 0){
    $('.button-map').on('click', function(){
      $('#map').find('#autocompleteMobile').children().detach().appendTo('#autocompleteDesktop');
      $('#map').removeClass('active-mobile');
    });
  }
}

module.exports = get_data;
}